import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import '@web/shared-digital-library/icons/svg-originals/gift.svg';
import '@web/shared-digital-library/icons/svg-originals/box-close.svg';
import '@web/shared-digital-library/icons/svg-originals/heart.svg';
import '@web/shared-digital-library/icons/svg-originals/info-question.svg';
import '@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
import '@web/shared-digital-library/icons/svg-originals/logout.svg';
import { mapGetters } from 'vuex';
import IconTextLink from '~/components/molecules/Header/IconTextLink.vue';
import { FAQ } from '~/const/faq';
import USE_MERCURE from '~/const/mercure';
import _logout from '~/helpers/logout-helper';
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
var CloseButton = function CloseButton() {
  return import('~/components/atoms/CloseButton.vue');
};
export default {
  name: 'AccountLayer',
  components: {
    IconTextLink: IconTextLink,
    CloseButton: CloseButton,
    MdmLink: MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      renderLink: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    user: 'user/me',
    locale: 'i18n/locale'
  })), {}, {
    accountDescription: function accountDescription() {
      return this.user ? this.$t('account-greeting', {
        name: this.user.firstName
      }) : this.$t('account-description');
    },
    accountIcon: function accountIcon() {
      return this.user ? 'account-connected' : 'account';
    },
    urlPrefix: function urlPrefix() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },
    accessUrl: function accessUrl() {
      var _this = this;
      var url = {
        dashboard: "/".concat(this.urlPrefix, "/account/dashboard"),
        orders: "/".concat(this.urlPrefix, "/account/orders"),
        profile: "/".concat(this.urlPrefix, "/account/personal-details/profile"),
        giftCards: "/".concat(this.urlPrefix, "/account/gift-voucher"),
        wishlist: "/".concat(this.urlPrefix, "/account/moodboard")
      };
      if (USE_MERCURE(this.locale.iso)) {
        url = {
          dashboard: this.user ? "/".concat(this.urlPrefix, "/user") : "/".concat(this.urlPrefix, "/login"),
          orders: "/".concat(this.urlPrefix, "/user/orders"),
          profile: "/".concat(this.urlPrefix, "/user/profile"),
          giftCards: "/".concat(this.urlPrefix, "/user/gift-cards"),
          wishlist: "/".concat(this.urlPrefix, "/user/wishlist"),
          // help: `/${this.urlPrefix}/help`,
          help: FAQ.find(function (e) {
            return e.language === _this.locale.iso;
          }).url
        };
      }
      this.forceRerenderLink();
      return url;
    },
    quickAccessItems: function quickAccessItems() {
      return [{
        name: 'orders',
        link: this.accessUrl.orders,
        icon: 'box-close',
        tracking: {
          event_label: 'Mes commandes'
        }
      }, {
        name: 'personal-info',
        link: this.accessUrl.profile,
        icon: 'account',
        tracking: {
          event_label: 'Mes informations personnelles'
        }
      }, {
        name: 'vouchers',
        link: this.accessUrl.giftCards,
        icon: 'gift',
        tracking: {
          event_label: 'Mes cartes cadeaux, bons d’achat ou avoirs'
        }
      }, {
        name: 'wishlist',
        link: this.accessUrl.wishlist,
        icon: 'heart',
        tracking: {
          event_label: 'Ma wishlist'
        }
      }, {
        name: 'help',
        icon: 'info-question',
        link: {
          FR: 'https://faq-france.maisonsdumonde.com',
          UK: 'https://help-uk.maisonsdumonde.com',
          PT: 'https://help-pt.maisonsdumonde.com',
          ES: 'https://faq-es.maisonsdumonde.com/es',
          IT: 'https://faq-italia.maisonsdumonde.com',
          CH: 'https://faq-suisse.maisonsdumonde.com',
          DE: 'https://faq-deutschland.maisonsdumonde.com',
          NL: 'https://faq-nederland.maisonsdumonde.com',
          AT: 'https://faq-oesterreich.maisonsdumonde.com',
          BE: {
            fr: 'https://faq-belgique.maisonsdumonde.com',
            nl: 'https://faq-belgie.maisonsdumonde.com/'
          }
        },
        tracking: {
          event_label: 'Aide et contact'
        }
      }];
    },
    logoutLink: function logoutLink() {
      if (USE_MERCURE(this.locale.iso)) {
        return this.$route.fullPath;
      }
      return "/".concat(this.urlPrefix, "/deconnexion.html");
    },
    helpItemIndex: function helpItemIndex() {
      return this.quickAccessItems.length - 1;
    }
  }),
  methods: {
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: 'Mon compte',
          event_label: ''
        }, data)
      });
    },
    logout: function logout() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _logout(_this2.$store);
            case 2:
              window.location.href = _this2.logoutLink;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    forceRerenderLink: function forceRerenderLink() {
      var _this3 = this;
      this.renderLink = false;
      this.$nextTick(function () {
        _this3.renderLink = true;
      });
    },
    navigate: function navigate(event, url) {
      this.tracking(event);
      window.location.assign(url);
    }
  }
};